import { fetchCities } from 'api'
import { citiesReceived } from '.'
import { AppThunk } from 'redux/store'

export const retrieveCities = (searchText): AppThunk => async dispatch => {
    dispatch(citiesReceived(await fetchCities(searchText)))
}
